export function arrayAddDuplicateSafe(array: any[], toAdd: any[] | any) {
  if (toAdd instanceof Array) {
    toAdd.forEach((item) => {
      if (array.indexOf(item) !== -1) {
        array.push(item);
      }
    });
  }

  if (array.indexOf(toAdd) === -1) {
    array.push(toAdd);
  }
}

/** Try to remove items and returns the removed items */
export function arrayRemoveItem(array: any[], item: any): any[] {
  let index = array.indexOf(item);
  if (index > -1) {
    return array.splice(index, 1);
  }

  return [];
}

export function arrayRemoveList(array: any[], items: any[]): any[] {
  return array.filter((item) => {
    return items.indexOf(item) === -1;
  });
}

export function arrayIntersect(a: any[], b: any[]) {
  return a.filter((x) => b.indexOf(x) !== -1);
}

export function sortBy<T>(
  items: T[],
  func: (el: T) => any,
  sort: 'asc' | 'desc' | null | undefined,
): T[] {
  if (items == null) {
    return [];
  }

  if (sort === 'asc') {
    return [...items].sort((a, b) => (func(a) >= func(b) ? 1 : -1));
  } else {
    return [...items].sort((a, b) => (func(a) <= func(b) ? 1 : -1));
  }
}

export const range = (start: number, end: number, step = 1): number[] =>
  Array(Math.floor((end - start) / step) + 1)
    .fill(0)
    .map((_, idx) => start + idx * step);
